import type { ColDef, ValueGetterParams } from 'ag-grid-community'

import { ImageCellRenderer, ImageTooltip } from '@/components/atoms/AGGrid'
import {
  defaultNumberComparator,
  defaultNumberValueFormatter,
  handleCellClass,
  textComparator,
} from '@/components/Grid/utils'
import { formatPriceValue, formatQuantityValue } from './formatters'

const pictureThumbnailWidth = 40
const picturesColumnDefaultWidth = 136
const getPicturesValue = (params: ValueGetterParams<unknown>): unknown => {
  const data = params.data
  if (!data || typeof data !== 'object' || !('pictures' in data)) return []
  const pictures = (data as { pictures?: unknown }).pictures
  return Array.isArray(pictures) ? pictures : []
}

/**
 * Reusable column types for the new compound Grid.
 * Focused on the compound grids that do not use the inventory default columns.
 */
export const gridColumnTypes: Record<string, ColDef<unknown>> = {
  default: {
    cellClass: handleCellClass,
  },
  text: {
    comparator: textComparator,
    filterParams: {
      filterOptions: ['contains', 'startsWith', 'blank'],
    },
  },
  numbers: {
    cellClass: 'flex items-center justify-end',
    cellStyle: { textAlign: 'right' },
    comparator: defaultNumberComparator,
    valueFormatter: defaultNumberValueFormatter,
  },
  quantity: {
    cellClass: 'flex items-center justify-end',
    valueFormatter: formatQuantityValue,
    cellEditorParams: {
      step: 1,
      showStepperButtons: true,
    },
  },
  price: {
    cellClass: 'flex items-center justify-end',
    valueFormatter: formatPriceValue,
  },
  dynamic: {
    filter: 'agSetColumnFilter',
  },
  pictures: {
    cellDataType: 'object',
    cellRenderer: ImageCellRenderer,
    tooltipComponent: ImageTooltip,
    editable: false,
    filter: false,
    valueGetter: getPicturesValue,
    suppressHeaderMenuButton: true,
    suppressFiltersToolPanel: true,
    suppressFillHandle: true,
    suppressSizeToFit: true,
    sortable: false,
    minWidth: pictureThumbnailWidth,
    width: picturesColumnDefaultWidth,
    maxWidth: picturesColumnDefaultWidth,
    cellStyle: { padding: 0 },
    getQuickFilterText: () => '',
  },
}
